<template>
  <div
    :class="`w-fit py-[6px] px-[10px] rounded-full border-[1px] text-[12px] font-medium rounded-full px-[4px] py-[2px] border-[1px] mb-0 ${activeClass}`"
  >
    {{ statusPillConfig.label }}
  </div>
</template>

<script>
import { CAMPAIGN_LIST_STATUS } from '../config'

export default {
  props: {
    status: {
      type: String,
      default: '-',
    },
  },
  computed: {
    statusPillConfig() {
      return CAMPAIGN_LIST_STATUS[this.status.replace(/\s/g, '_').toLowerCase()] || {
        label: '-',
        class: 'border-none',
      }
    },
    activeClass() {
      const { style, class: bodyClass } = this.statusPillConfig
      if (bodyClass) return bodyClass
      return `!bg-[${style.subColor}] !text-[${style.textColor || style.mainColor}] !border-[${style.mainColor}]`
    },
  },
}
</script>
